import React from "react";

import { useTranslation } from "react-i18next";

import { ReactComponent as ToastIcon } from "../../../Assets/Images/ToastIcon.svg";
import { FormItemsWrap } from "../../molecules/Wrap/Wrap";
import { Text1 } from "../Typography/Text/Text";

export const NoRecordsFound = ({
  label,
  isError,
  textPosition,
  textColor,
  borderRadius,
  padding,
  addBorder,
  mB
}) => {
  const { t } = useTranslation(["validation"]);
  return (
    <FormItemsWrap
      width={"100%"}
      bgColor={isError ? "#FFD8D5" : "#F2F2F7"}
      height={"32px"}
      direction={"row"}
      alignItems={"center"}
      justifyContent={textPosition || "center"}
      borderRadius={borderRadius}
      padding={padding}
      addBorder={addBorder}
      mB={mB}
    >
      <FormItemsWrap direction={"row"} gap={"8px"}>
        <ToastIcon
          role="img"
          type="img"
          aria-label="toast Icon"
          fill={isError ? "#FF6259" : "#AEAEB2"}
        />
        <Text1
          color={textColor || isError ? "#FF3B30" : "#8E8E93"}
          text={
            label ? label : isError ? t("error-occured") : t("no-records-found")
          }
        />
      </FormItemsWrap>
    </FormItemsWrap>
  );
};
